import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
const { createUniqueId } = common;


import tpl from './dom.html';
import style from './style.less';

const COUPON_STATUS = {
    STATUS_NEW: 1,
    STATUS_RECEIVED: 2,
    STATUS_FAILED: 3,
    STATUS_USED: 4,
    STATUS_EXPIRED: 5,
    STATUS_LOCKED_NEW: 6,
    STATUS_RECEIVE_EXPIRED: 7,
};

const btnIdBeforeRecv = createUniqueId();
const btnIdAfterRecv = createUniqueId();

const CouponList = (props) => {

    const { title = '', infos = [], ignoreCommonCoupon = false } = props || {};
    const { btnNameBeforeRecv = '一键领取优惠券', btnNameAfterRecv = '立即使用优惠券' } = props || {};
    const { onCouponClick, onBatchRecvClick, onBatchUseClick } = props || {};

    // 忽略通用红包
    if (ignoreCommonCoupon) {
        let index = -1;
        infos.some((item, i) => {
            if ( item.giftInfo && item.giftInfo.type === 2 ) {
                index = i
                return true;
            }
        })
        if (index > -1) {
            infos.splice(index, 1);
        }
    }

    let firstLine = [];
    let secondLine = [];
    if (infos.length < 5) {
        firstLine = infos.slice();
    } else {
        const len = Math.ceil(infos.length / 2);
        firstLine = infos.slice(0, len);
        secondLine = infos.slice(len);
    }

    // 过滤出未领取的红包
    const newCouponInfos = infos.filter((item) => item.giftInfo && item.giftInfo.status === COUPON_STATUS.STATUS_NEW);
    // 获取红包id集合
    const giftIds = newCouponInfos.map((item) => item.giftInfo.gift_id);

    const data = {
        title,
        firstLine,
        secondLine,
        btnIdBeforeRecv,
        btnNameBeforeRecv,
        btnIdAfterRecv,
        btnNameAfterRecv,
        isRecvAll: giftIds.length === 0,
    };
    const events = {
        onCouponClick(listName, index) {
            onCouponClick && onCouponClick(data[listName][index], listName, index)
        },
        onBatchRecvClick() {
            if (onBatchRecvClick) {
                const result = onBatchRecvClick(giftIds);
                if (result) {
                    dom.$id(btnIdBeforeRecv).style.display = 'none';
                    dom.$id(btnIdAfterRecv).style.display = 'block';
                }
            }
        },
        onBatchUseClick() {
            onBatchUseClick && onBatchUseClick();
        }
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
}

export default CouponList;

export function changeCouponListBtnStatus(status) {
    const btn = dom.$id(btnIdBeforeRecv)
    if (btn) {
        if (status === 0) { //未领取
            dom.$id(btnIdBeforeRecv).style.display = 'block';
            dom.$id(btnIdAfterRecv).style.display = 'none';
        }
        if (status === 1) { //已领取
            dom.$id(btnIdBeforeRecv).style.display = 'none';
            dom.$id(btnIdAfterRecv).style.display = 'block';
        }
    }
}